import { render, staticRenderFns } from "./TheMain.vue?vue&type=template&id=7b4e0f69&"
import script from "./TheMain.vue?vue&type=script&lang=js&"
export * from "./TheMain.vue?vue&type=script&lang=js&"
import style0 from "./TheMain.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports